import { UploadOneIcon } from '@/components/icons'
import { IconButton, Stack, Typography } from '@mui/material'
import { ChangeEvent, FC } from 'react'
interface Props {
  accept: string
  title: string
  sx?: any
  file?: any
  icon?: boolean
  padding?: string
  index?: number | undefined
  handleChange: (
    e: ChangeEvent<HTMLInputElement>) => void
  nameFile?: string
}

const InputFile: FC<Props> = ({
  accept,
  title,
  sx,
  file,
  icon = false,
  padding = '6px 10px',
  index = -1,
  handleChange,
  nameFile,
}) => {


  return (
    <>
      <IconButton
        sx={{
          backgroundColor: 'rgba(4, 71, 68, 0.1)',
          borderRadius: "5px",
          '&:hover': {
            backgroundColor: 'rgba(4, 71, 68, 0.1)',
          },
          ...sx,
        }}
        component="label"
      >
        <input
          hidden
          accept={accept}
          // type={"file"}
          value={file}
          id={"csvFileInput"}
          onChange={handleChange}
        />
        <Stack
          alignItems="center"
        >
          <Stack alignItems="center" sx={{ color: "#004744", mb: "14px" }}>
            <UploadOneIcon />
          </Stack>
          <Typography
            sx={{ width: "186px", height: "14px", fontWeight: "500", letterSpacing: "0.02em", lineHeight: "1.4", color: "#004744", }}
          >
            {nameFile ? nameFile : title}
          </Typography>
          <Stack alignItems="center">
            <Typography sx={{ color: "#000000", mt: "11px" }}>or select</Typography>
          </Stack>
        </Stack>
      </IconButton>
    </>
  )
}

export default InputFile